import { render } from "./OrderModifier.vue?vue&type=template&id=276d98f0&scoped=true"
import script from "./OrderModifier.vue?vue&type=script&lang=js"
export * from "./OrderModifier.vue?vue&type=script&lang=js"

import "./OrderModifier.vue?vue&type=style&index=0&id=276d98f0&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/kds-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276d98f0"]])

export default __exports__